import { render, staticRenderFns } from "./IBS-quality-widget.vue?vue&type=template&id=1e7d3e6c"
import script from "./IBS-quality-widget.vue?vue&type=script&lang=js"
export * from "./IBS-quality-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports